import { render, staticRenderFns } from "./CustomsManagerSelect.vue?vue&type=template&id=8415a7c0"
import script from "./CustomsManagerSelect.vue?vue&type=script&lang=js"
export * from "./CustomsManagerSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports